import React from 'react';
import styled from 'styled-components';
import { SubTitle, Register } from './AboutStyle'; 

const Container = styled.div`
  text-align: center; 
  
  
`;

const Wrapper = styled.div`
  position: relative;
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-direction: column;
  width: 100%;
  max-width: 1550px;
  
  @media (max-width: 960px) {
    flex-direction: column;
  }
`;

const Heading = styled.h1`
  font-size: 42px;
  font-weight: 700;
  margin-bottom: 40px;
  margin-top: 0px;
  color: ${({ theme }) => theme.text_primary};
  @media (max-width: 960px) {
    font-size: 32px;
  }
`;

const About = () => {
  return (
    <>
      <Container id='about'>
        <Wrapper>
          <Heading>About</Heading>
          <SubTitle>
            Nirman'24 is the flagship event organized by ORCES, bringing together budding civil engineers, industry professionals, and academic experts under one roof. This annual event showcases the latest trends, innovations, and technologies in the civil engineering domain, offering a unique opportunity for students to learn, network, and compete.
            The event includes a series of technical competitions, workshops, and exhibitions, all designed to challenge participants and encourage creative problem-solving. Nirman'24 serves as a platform for students to demonstrate their talents, collaborate on projects, and gain insights from leading experts in the field.
          </SubTitle>
          <Register>Click on the Events below to Register!!</Register>
        </Wrapper>
      </Container>
    </>
  );
};

export default About;
